export const CHANGE_LOCALE_REQUESTED = 'CHANGE_LOCALE_REQUESTED'
export const CHANGE_LOCALE_RECEIVED = 'CHANGE_LOCALE_RECEIVED'
export const SELECT_CHANGE_LOCALE_REQUESTED = 'SELECT_CHANGE_LOCALE_REQUESTED'
